import { Typography } from "antd"
import { useTranslation } from "react-i18next"

import styles from "../../shell.module.less"

const { Title, Text } = Typography

// Demo / External Demo (§18.2, RCDM-1-05): Configure renders for UI parity, but neither its Profile
// nor its Business tab mounts, so nothing is loaded and nothing can be changed. The URL stays
// whatever the merchant navigated to.
const DemoModePlaceholder = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.wizard}>
      <div className={styles.main}>
        <div className={`${styles.mainScroll} ${styles.placeholder}`}>
          <Title level={4}>{t("Configure isn't available in demo mode")}</Title>
          <Text type="secondary">
            {t("This section is disabled while you're viewing the demo experience.")}
          </Text>
        </div>
      </div>
    </div>
  )
}

export default DemoModePlaceholder
